// import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary

// function SupplyChainManagement() {

//     const documents = [
//       {
//         title: "CARGO AND TOWAGE APPROVAL",
//         modified: "2019/08/02 11:23 AM",
//         items: [
//           "Notification_of_intention_to_build_0.",
//           "INNotification_of_intention_to_build_0.",
//         ],
//       },
//       {
//         title: "Casualty Report",
//         modified: "2019/08/05  10.35 AM",
//         items: [
//           "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
//           "INS-701-08-03 Container Inspection Form",
//           "INS-701-09-01 Towage Inspection",
//         ],
//       },
//       {
//         title: "CARGO AND TOWAGE APPROVAL",
//         modified: "2019/08/05  10.35 AM",
//         items: [
//           "Notification_of_intention_to_build_0.",
//           "INNotification_of_intention_to_build_0.",
//         ],
//       },
//     ];

//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">
//         SUPPLY CHAIN MANAGEMENT
//       </div>

//       <div className="service-box mb-5 mb-sm-4">
//         Communication to Suppliers :<br />{" "}
//         <a
//           className="text-decoration-none text-green-38B652 font-600"
//          href="/Documents/Opportunitie/SupplyChainManagement/SCM_COMMUNICATION_TO_SUPPLIERS_INVOICES.pdf" target="_blank" rel="noopener noreferrer">

//           Click here to view the document
//         </a>
//       </div>

//       <p className="font-17 text-primary-color mb-3">
//         SAMSA's Supply Chain Management manages all procurement activities,
//         which include procurement of goods and services required by the
//         organization to ensure optimal, safe and cost effective procurement.
//       </p>

//       <p className="font-17 text-primary-color mb-3">
//         Proper and successful SAMSA procurement rest upon certain core
//         principles of behaviour – t​he Five Pillars of Procurement.
//       </p>

//       <p className="font-17 text-primary-color mb-1">
//         <b>The Five Pillars are </b>
//       </p>

//       <ul className="list-order mb-3">
//         <li>Value for Money</li>
//         <li>Open and Effective Competition</li>
//         <li>Ethics and Fair Dealing</li>
//         <li>Accountability and Reporting</li>
//         <li>Equity</li>
//       </ul>

//       <p className="font-17 text-primary-color mb-3">
//         Prospective suppliers interested in pursuing opportunities with SAMSA,
//         are encourage to register their information of National Treasury Central
//         Supplier Database.{" "}
//       </p>

//       <p className="font-17 text-primary-color mb-3">
//         The service is a self-registration application and suppliers are
//         requested to submit their CSD Registration Summary Report to{" "}
//         <a
//           className="text-decoration-none text-green-38B652"
//           href="mailto:Tkhethani@samsa.org.za"
//         >
//           Tkhethani@samsa.org.za
//         </a>{" "}
//         when submitting offers for quotes and also attached their BBBEE
//         certificate.
//       </p>

//       <p className="font-17 text-primary-color mb-4">
//         Enquiries regarding the process to register on CSD can be directed to
//         National Treasury by calling 012 406 9222.
//       </p>

//       <div className="row g-3 mb-4">
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="https://secure.csd.gov.za/"
//           >
//             CSD REGISTRATION
//           </a>
//         </div>
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="https://etenders.treasury.gov.za/"
//           >
//             eTender Publication
//           </a>
//         </div>
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block" 
//              href="/Documents/Opportunitie/SupplyChainManagement/B-BBEE_CERTIFICATE_GEN0656-V1.pdf" target="_blank" rel="noopener noreferrer">

//             BBBEE CERTIFICATE
//           </a>
//         </div>
//       </div>

//       <p className="font-17 text-primary-color mb-4">
//         Prospective suppliers are encourage to visit the following page to
//         access SAMSA RFQ's and Tenders and also browse through SAMSA Tender
//         Filters to check for “Bid Opening Register, Awarded and Cancelled
//         Tenders"
//       </p>

//       <div className="row g-3 mb-4">
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="/tenders"
//           >
//             SAMSA TENDERS
//           </a>
//         </div>
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="https://www.samsa.org.za/Pages/RFQ-Submissions.aspx"
//           >
//             ​​​SAMSA RFQ​​'​S​
//           </a>
//         </div>
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="https://www.samsa.org.za/Pages/MSP-RFQ-SUBMISSIONS.aspx"
//           >
//             ​​​​​MSP RFQ​​'​S​
//           </a>
//         </div>
//         <div className="col-auto">
//           <a
//             className="btn-green-38B652 text-decoration-none d-inline-block"
//             target="_blank"
//             href="https://www.samsa.org.za/Pages/Fleet-Management.aspx"
//           >
//             FLEET MANAGEMENT
//           </a>
//         </div>
//       </div>

//       <div className="accordion blackTab" id="blackTab">
//         <div className="accordion-item">
//           <h2 className="accordion-header">
//             <button
//               className="accordion-button"
//               type="button"
//               data-bs-toggle="collapse"
//               data-bs-target="#blackTabOne"
//               aria-expanded="true"
//               aria-controls="blackTabOne"
//             >Code Of Conduct</button>
//           </h2>
//           <div
//             id="blackTabOne"
//             className="accordion-collapse collapse show"
//             data-bs-parent="#blackTab"
//           >
//             <div className="accordion-body">
//               <ul className="strip-ul">
//                 {documents.map((doc, index) => (
//                   <li key={index}>
//                     <div className="row g-4">
//                       <div className="col-auto">
//                         <img src={pdfIcon} alt="PDF icon" />
//                       </div>
//                       <div className="col">
//                         <div className="row g-4">
//                           <div className="col-md">
//                             <div className="font-18 font-600">File Name</div>
//                             <div className="font-16 font-400">
//                               <p className="text-orange-ef3e33 text-uppercase">
//                                 {doc.title}
//                               </p>
//                               <ul className="list">
//                                 {doc.items.map((item, i) => (
//                                   <li key={i}>{item}</li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </div>
//                           <div className="col-md-auto">
//                             <div className="font-18 font-600">Modified</div>
//                             <div className="font-16 font-400">
//                               {doc.modified}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//         <div className="accordion-item">
//           <h2 className="accordion-header">
//             <button
//               className="accordion-button collapsed"
//               type="button"
//               data-bs-toggle="collapse"
//               data-bs-target="#blackTabTwo"
//               aria-expanded="false"
//               aria-controls="blackTabTwo"
//             >
//               General Conditions of Contract
//             </button>
//           </h2>
//           <div
//             id="blackTabTwo"
//             className="accordion-collapse collapse"
//             data-bs-parent="#blackTab"
//           >
//             <div className="accordion-body">
//               <ul className="strip-ul">
//                 {documents.map((doc, index) => (
//                   <li key={index}>
//                     <div className="row g-4">
//                       <div className="col-auto">
//                         <img src={pdfIcon} alt="PDF icon" />
//                       </div>
//                       <div className="col">
//                         <div className="row g-4">
//                           <div className="col-md">
//                             <div className="font-18 font-600">File Name</div>
//                             <div className="font-16 font-400">
//                               <p className="text-orange-ef3e33 text-uppercase">
//                                 {doc.title}
//                               </p>
//                               <ul className="list">
//                                 {doc.items.map((item, i) => (
//                                   <li key={i}>{item}</li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </div>
//                           <div className="col-md-auto">
//                             <div className="font-18 font-600">Modified</div>
//                             <div className="font-16 font-400">
//                               {doc.modified}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//         <div className="accordion-item">
//           <h2 className="accordion-header">
//             <button
//               className="accordion-button collapsed"
//               type="button"
//               data-bs-toggle="collapse"
//               data-bs-target="#blackTabThree"
//               aria-expanded="false"
//               aria-controls="blackTabThree"
//             >
//               Legislation
//             </button>
//           </h2>
//           <div
//             id="blackTabThree"
//             className="accordion-collapse collapse"
//             data-bs-parent="#blackTab"
//           >
//             <div className="accordion-body">
//               <ul className="strip-ul">
//                 {documents.map((doc, index) => (
//                   <li key={index}>
//                     <div className="row g-4">
//                       <div className="col-auto">
//                         <img src={pdfIcon} alt="PDF icon" />
//                       </div>
//                       <div className="col">
//                         <div className="row g-4">
//                           <div className="col-md">
//                             <div className="font-18 font-600">File Name</div>
//                             <div className="font-16 font-400">
//                               <p className="text-orange-ef3e33 text-uppercase">
//                                 {doc.title}
//                               </p>
//                               <ul className="list">
//                                 {doc.items.map((item, i) => (
//                                   <li key={i}>{item}</li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </div>
//                           <div className="col-md-auto">
//                             <div className="font-18 font-600">Modified</div>
//                             <div className="font-16 font-400">
//                               {doc.modified}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//         <div className="accordion-item">
//           <h2 className="accordion-header">
//             <button
//               className="accordion-button collapsed"
//               type="button"
//               data-bs-toggle="collapse"
//               data-bs-target="#blackTabFourth"
//               aria-expanded="false"
//               aria-controls="blackTabFourth"
//             >
//               SBD Forms
//             </button>
//           </h2>
//           <div
//             id="blackTabFourth"
//             className="accordion-collapse collapse"
//             data-bs-parent="#blackTab"
//           >
//             <div className="accordion-body">
//               <ul className="strip-ul">
//                 {documents.map((doc, index) => (
//                   <li key={index}>
//                     <div className="row g-4">
//                       <div className="col-auto">
//                         <img src={pdfIcon} alt="PDF icon" />
//                       </div>
//                       <div className="col">
//                         <div className="row g-4">
//                           <div className="col-md">
//                             <div className="font-18 font-600">File Name</div>
//                             <div className="font-16 font-400">
//                               <p className="text-orange-ef3e33 text-uppercase">
//                                 {doc.title}
//                               </p>
//                               <ul className="list">
//                                 {doc.items.map((item, i) => (
//                                   <li key={i}>{item}</li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </div>
//                           <div className="col-md-auto">
//                             <div className="font-18 font-600">Modified</div>
//                             <div className="font-16 font-400">
//                               {doc.modified}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SupplyChainManagement;




import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
import { WebApiURL } from '../../../Constants/Constants';
import React, { useEffect, useMemo, useState } from 'react';
import { useFileContext } from '../../../Contexts/FileContext';
import CryptoJS from "crypto-js";
import { encryptFileIdValue } from "../../../utils/encryption";

function SupplyChainManagement() {
  const [activeIndex, setActiveIndex] = useState(0);
  const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
  const secretKey = "MySAMSASecretKey2025"; // same as backend

  const encryptFileId = (fileId) => {
    const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
    return encodeURIComponent(ciphertext);
  };
  const { setComponentName, setSection, documents, loading } = useFileContext();
  useEffect(() => {
    setComponentName("Supply Chain Management");
  }, [setComponentName]);
  // Extract unique sections dynamically
  const sections = useMemo(() => {
    const sectionSet = new Set();
    documents?.forEach((doc) => {
      const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
      if (section) sectionSet.add(section);
    });
    return Array.from(sectionSet);
  }, [documents]);
  const renderDocumentsBySection = (sectionName) => {
    const docs = documents?.filter(doc =>
      String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
    );
    const grouped = docs?.reduce((acc, doc) => {
      const folder = doc?.folderName || doc?.section || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});
    return (
      <ul className="strip-ul">
        {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
          <li key={idx}>
            <div className="row g-4">
              <div className="col-auto">
                <img src={pdfIcon} alt="PDF icon" />
              </div>
              <div className="col">
                <div className="row g-4">
                  <div className="col-md">
                    <div className="font-18 font-600">File Name</div>
                    <div className="font-16 font-400">
                      <p className="text-orange-ef3e33 text-uppercase">
                        {folderName}
                      </p>
                      <ul className="list">
                        {folderDocs.map((doc, i) => (
                          <li key={i}>
                            {/* <a
                            href={`${WebApiURL}File/view/${encodeURIComponent(doc.fileId)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {doc.fileName}
                          </a> */}
                            <a
                              href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
                              //href={`${WebApiURL}File/view/${encodeBase64(doc.fileId.toString())}`}
                              // target="_blank"
                              rel="noopener noreferrer"
                            >{doc.fileName}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-auto">
                    <div className="font-18 font-600">Modified</div>
                    <div className="font-16 font-400">
                      {folderDocs[0]?.modifiedDate
                        ? new Date(folderDocs[0].modifiedDate).toLocaleString()
                        : "—"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <>
      <div className="service-title text-green-38B652 font-700 mb-3">
        Supply Chain Management
        <span className="text-orange-ef3e33 font-400"></span>
      </div>
      <div className="service-box mb-5 mb-sm-4">
        Communication to Suppliers :<br />{" "}
        <a
          className="text-decoration-none text-green-38B652 font-600"
          href="/Documents/Opportunitie/SupplyChainManagement/SCM_COMMUNICATION_TO_SUPPLIERS_INVOICES.pdf" target="_blank" rel="noopener noreferrer">

          Click here to view the document
        </a>
      </div>
      <p className="font-17 text-primary-color mb-3">
        SAMSA's Supply Chain Management manages all procurement activities,
        which include procurement of goods and services required by the
        organization to ensure optimal, safe and cost effective procurement.
      </p>

      <p className="font-17 text-primary-color mb-3">
        Proper and successful SAMSA procurement rest upon certain core
        principles of behaviour – t​he Five Pillars of Procurement.
      </p>

      <p className="font-17 text-primary-color mb-1">
        <b>The Five Pillars are </b>
      </p>

      <ul className="list-order mb-3">
        <li>Value for Money</li>
        <li>Open and Effective Competition</li>
        <li>Ethics and Fair Dealing</li>
        <li>Accountability and Reporting</li>
        <li>Equity</li>
      </ul>

      <p className="font-17 text-primary-color mb-3">
        Prospective suppliers interested in pursuing opportunities with SAMSA,
        are encourage to register their information of National Treasury Central
        Supplier Database.{" "}
      </p>

      <p className="font-17 text-primary-color mb-3">
        The service is a self-registration application and suppliers are
        requested to submit their CSD Registration Summary Report to{" "}
        <a
          className="text-decoration-none text-green-38B652"
          href="mailto:Tkhethani@samsa.org.za"
        >
          Tkhethani@samsa.org.za
        </a>{" "}
        when submitting offers for quotes and also attached their BBBEE
        certificate.
      </p>
      <p className="font-17 text-primary-color mb-4">
        Enquiries regarding the process to register on CSD can be directed to
        National Treasury by calling 012 406 9222.
      </p>

      <div className="row g-3 mb-4">
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href="https://secure.csd.gov.za/"
          >
            CSD REGISTRATION
          </a>
        </div>
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href="https://etenders.treasury.gov.za/"
          >
            eTender Publication
          </a>
        </div>
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            href="/Documents/Opportunitie/SupplyChainManagement/B-BBEE_CERTIFICATE_GEN0656-V1.pdf" target="_blank" rel="noopener noreferrer">

            BBBEE CERTIFICATE
          </a>
        </div>
      </div>
      <p className="font-17 text-primary-color mb-4">
        Prospective suppliers are encourage to visit the following page to
        access SAMSA RFQ's and Tenders and also browse through SAMSA Tender
        Filters to check for “Bid Opening Register, Awarded and Cancelled
        Tenders"
      </p>
      <div className="row g-3 mb-4">
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href="/tenders"
          >
            SAMSA TENDERS
          </a>
        </div>
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href="/opportunities?section=RFQ-Submissions"
          >
            SAMSA RFQ​​'​S
          </a>
        </div>
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href=""
          >
            MSP RFQ​​'​S
          </a>
        </div>
        <div className="col-auto">
          <a
            className="btn-green-38B652 text-decoration-none d-inline-block"
            target="_blank"
            href="/opportunities?section=Fleet-Management"
          >
            FLEET MANAGEMENT
          </a>
        </div>
      </div>

      <div className="row g-3 g-sm-4 g-md-4">
        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            {sections?.map((sectionName, idx) => (
              <div className="accordion-item" key={sectionName}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#section-${idx}`}
                    aria-expanded={idx === 0 ? "true" : "false"}
                    aria-controls={`section-${idx}`}
                    onClick={() => setActiveIndex(idx)}
                  >
                    {sectionName}
                  </button>
                </h2>
                <div
                  id={`section-${idx}`}
                  className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
                  data-bs-parent="#blackTab"
                >
                  <div className="accordion-body px-0">
                    {loading ? (
                      <div>Loading documents...</div>
                    ) : (
                      renderDocumentsBySection(sectionName)
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </>
  );
}

export default SupplyChainManagement;


